<script>
import { mapGetters } from 'vuex';
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxTextEditor from '../../../shared/reybex/RbxTextEditor';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'DepartmentBasicInfoForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxTextEditor,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    department: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'department',
    };
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
};
</script>

<template>
  <div class="department-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md8 xs12>
        <v-layout row wrap>
          <v-flex v-if="isFieldVisible('department.name')" md4 py-0>
            <v-text-field
              v-model="department.name"
              label="Abteilung"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex md8 py-0/>

          <v-flex v-if="isFieldVisible('department.isDelete')" md4 py-0>
            <v-switch
              v-model="department.isDelete"
              label="Gelöscht"
              height="0"
              :readonly="!auth.hasDeleteRights"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
